import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MarketingMessagesManagerComponent } from './components/marketing-messages-manager.component';
import { MarketingMessagesManagerService } from './services/marketing-messages-manager.service';
import { MarketingMessagesManagerLayoutsComponent } from './components/marketing-messages-manager-layouts/marketing-messages-manager-layouts.component';
import { MarketingContentFieldsComponent } from './components/marketing-content-fields/marketing-content-fields.component';
import { MarketingMessagesTwoColumnComponent } from './components/marketing-messages-manager-layouts/marketing-messages-two-column/marketing-messages-two-column.component';
import { MarketingMessagesOneColumnComponent } from './components/marketing-messages-manager-layouts/marketing-messages-one-column/marketing-messages-one-column.component';
import { MarketingMessagesSlotLayoutComponent } from './components/marketing-messages-manager-layouts/marketing-messages-slot-layout/marketing-messages-slot-layout.component';
import { MarketingMessagesThreeColumnComponent } from './components/marketing-messages-manager-layouts/marketing-messages-three-column/marketing-messages-three-column.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    MarketingMessagesManagerComponent
  ],
  declarations: [
    MarketingMessagesManagerComponent,
    MarketingMessagesManagerLayoutsComponent,
    MarketingContentFieldsComponent,
    MarketingMessagesTwoColumnComponent,
    MarketingMessagesOneColumnComponent,
    MarketingMessagesSlotLayoutComponent,
    MarketingMessagesThreeColumnComponent,
  ],
  providers: [
    MarketingMessagesManagerService
  ],
  entryComponents: [
    MarketingMessagesManagerComponent
  ]
})
export class MarketingMessagesManagerModule { }
